import { useContext } from "react";
import { GlobalContext } from "../Context/GlobalContext";

function useGlobal() {
  return useContext(GlobalContext);
}

export default useGlobal;
